import { render, staticRenderFns } from "./txnInfo.vue?vue&type=template&id=325eb340&scoped=true&"
import script from "./txnInfo.vue?vue&type=script&lang=js&"
export * from "./txnInfo.vue?vue&type=script&lang=js&"
import style0 from "./txnInfo.vue?vue&type=style&index=0&id=325eb340&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325eb340",
  null
  
)

export default component.exports